import type { FunctionalComponent } from 'preact';

import { cnBubble } from '../bubble.constants.js';

import './bubble__tail.css';

import './_color/bubble__tail_color.css';

export interface BubbleTailProps {
    color?: string;
    isFlippedHorizontally?: boolean;
    isFlippedVertically?: boolean;
}

export const BubbleTail: FunctionalComponent<BubbleTailProps> = ({
    color,
    isFlippedHorizontally,
    isFlippedVertically,
}) => (
    <svg
        style={{ transform: `scaleX(${isFlippedHorizontally ? -1 : 1}) scaleY(${isFlippedVertically ? -1 : 1})` }}
        className={cnBubble('tail', {
            color: color,
        })}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 54 16"
    >
        <path d="M12 11.082c0 1.09 1.87 1.585 2.508.703C17.94 7.045 25.15 0 37.697 0H12v11.082Z" fill="currentColor" />
    </svg>
);
